import { Box, Button, DropdownMenu, ShimmerText } from '@betterment/samba-react';

import { useDirectTradingAccountInflowOptions } from '../../../../Shared/hooks/useDirectTradingAccountInflowOptions/useDirectTradingAccountInflowOptions';
import { locationAssign } from '../../../../Shared/path-helpers';
import { urlBuilder } from '../../../../Shared/urlBuilder';

type Options = NonNullable<ReturnType<typeof useDirectTradingAccountInflowOptions>>;

const itemCss = { whiteSpace: 'nowrap', paddingY: 'space.100' };
const loadingItemCss = { ...itemCss, width: '300px' };

const LoadingItems = () => (
  <>
    <DropdownMenu.Item css={loadingItemCss}>
      <ShimmerText textStyle="text50" />
    </DropdownMenu.Item>
    <DropdownMenu.Item css={loadingItemCss}>
      <ShimmerText textStyle="text50" />
    </DropdownMenu.Item>
  </>
);

const Items: React.FC<{ options: Options }> = ({ options }) => {
  const { depositOption, transferOption } = options;

  const navigateToDepositSetup = () => {
    const subAccountId = depositOption.destinationLegacySubAccountId;
    const returnTo = window.location.pathname;
    locationAssign(urlBuilder.appDepositSetup.absolute({ subAccountId, returnTo }));
  };

  const navigateToTransferSetup = ({ option }: { option: NonNullable<Options['transferOption']> }) => {
    const returnTo = window.location.pathname;
    const { sourceLegacySubAccountId: subAccountId, destinationLegacySubAccountId: destinationAccountId } = option;
    locationAssign(
      urlBuilder.showSubAccountTransferSetup.absolute({
        subAccountId,
        destination_account_id: destinationAccountId,
        returnTo,
      })
    );
  };

  return (
    <Box css={{ width: 'min-content' }}>
      <DropdownMenu.Item css={itemCss} onSelect={navigateToDepositSetup}>
        Deposit from a bank account
      </DropdownMenu.Item>
      {transferOption && (
        <DropdownMenu.Item css={itemCss} onSelect={() => navigateToTransferSetup({ option: transferOption })}>
          Transfer from a Betterment account
        </DropdownMenu.Item>
      )}
    </Box>
  );
};

export const AddCashButton: React.FC<{ accountId: string }> = ({ accountId }) => {
  const options = useDirectTradingAccountInflowOptions({ accountId });

  return (
    <DropdownMenu>
      <DropdownMenu.Trigger asChild={true}>
        <Button variant="textPrimary">Add cash</Button>
      </DropdownMenu.Trigger>
      <DropdownMenu.Content align="end" side="bottom">
        {options ? <Items options={options} /> : <LoadingItems />}
      </DropdownMenu.Content>
    </DropdownMenu>
  );
};
